<div class="crud-item-page">
  <form [formGroup]="form">
    <div class="crud-item-section">
    
      <span>
        <mat-form-field matTooltip="Asset Type Id" [matTooltipDisabled]="disabledTooltip(this.assetTypeId)">
          <mat-label i18n="@@type.AssetType.assetTypeId">Asset Type Id</mat-label>
          <input matInput formControlName="assetTypeId" id="assetTypeId"              
              (ngModelChange)="assetTypeIdChanging($event)" [(ngModel)]="item.assetTypeId"              
              (ngModelChange)="assetTypeIdChanged($event)" #assetTypeId              
              type="number" placeholder="Asset Type Id">
        </mat-form-field>
      </span>

      
      <span>
        <mat-form-field matTooltip="Name" [matTooltipDisabled]="disabledTooltip(this.name)" class="crud-input-wider">
          <mat-label i18n="@@type.AssetType.name">Name</mat-label>
          <input matInput formControlName="name" id="name"              
              (ngModelChange)="nameChanging($event)" [(ngModel)]="item.name"              
              (ngModelChange)="nameChanged($event)" #name              
              maxlength="255" placeholder="Name">
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>

    

    <div class="crud-item-section">
      <h2>Asset Transfer</h2>

    </div>

    <div class="crud-item-section">

    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
            formControlName="transferOnApproval" id="transferOnApproval"              
            (ngModelChange)="transferOnApprovalChanging($event)" [(ngModel)]="item.transferOnApproval"              
            (ngModelChange)="transferOnApprovalChanged($event)" #transferOnApproval i18n="@@type.AssetType.transferOnApproval">
Transfer On Approval Immediately</mat-slide-toggle>        
      </span>
    </span>
  </div>

    <div class="crud-item-section">
      <h2>Maintenance</h2>

    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Maintenance Aspect Requirement from the list" [matTooltipDisabled]="disabledTooltip(this.maintenanceAspectRequirement)">
          <mat-label i18n="@@type.AssetType.maintenanceAspectRequirement">Maintenance Aspect</mat-label>
          <mat-select formControlName="maintenanceAspectRequirement" id="maintenanceAspectRequirement"              
              (ngModelChange)="maintenanceAspectRequirementChanging($event)" [(ngModel)]="item.maintenanceAspectRequirement"              
              (ngModelChange)="maintenanceAspectRequirementChanged($event)" #maintenanceAspectRequirement              
              placeholder="Maintenance Aspect Requirement">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let maintenanceAspectRequirement of maintenanceAspectRequirementSelectionList" [value]="maintenanceAspectRequirement.code">
              {{maintenanceAspectRequirement.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>


    <div class="crud-item-section">
      
      <span>
        <mat-form-field matTooltip="Select a Maintenance Type from the list" [matTooltipDisabled]="disabledTooltip(this.maintenanceType)">
          <mat-label i18n="@@type.AssetType.maintenanceType">Maintenance Type</mat-label>
          <mat-select formControlName="maintenanceType" id="maintenanceType"              
              (ngModelChange)="maintenanceTypeChanging($event)" [(ngModel)]="item.maintenanceType"              
              (ngModelChange)="maintenanceTypeChanged($event)" #maintenanceType              
              placeholder="Maintenance Type">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let maintenanceType of maintenanceTypeSelectionList" [value]="maintenanceType.code">
              {{maintenanceType.code}} ({{maintenanceType.meaning}})
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="visualInspection" id="visualInspection"              
              (ngModelChange)="visualInspectionChanging($event)" [(ngModel)]="item.visualInspection"              
              (ngModelChange)="visualInspectionChanged($event)" #visualInspection i18n="@@type.AssetType.visualInspection">
Visual Inspection          </mat-slide-toggle>        
        </span>
      </span>

    </div>

    <div class="crud-item-section">

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="periodicMaintenance" id="periodicMaintenance"              
              (ngModelChange)="periodicMaintenanceChanging($event)" [(ngModel)]="item.periodicMaintenance"              
              (ngModelChange)="periodicMaintenanceChanged($event)" #periodicMaintenance i18n="@@type.AssetType.periodicMaintenance">
Weekly/Periodic Maintenance          </mat-slide-toggle>        
        </span>
      </span>
    
      <span>
        <mat-form-field matTooltip="Weekly/Periodic Maintenance Days" [matTooltipDisabled]="disabledTooltip(this.periodicMaintenanceDays)">
          <mat-label i18n="@@type.AssetType.periodicMaintenanceDays">Weekly/Periodic Maintenance Days</mat-label>
          <input matInput formControlName="periodicMaintenanceDays" id="periodicMaintenanceDays"              
              (ngModelChange)="periodicMaintenanceDaysChanging($event)" [(ngModel)]="item.periodicMaintenanceDays"              
              (ngModelChange)="periodicMaintenanceDaysChanged($event)" #periodicMaintenanceDays              
              type="number" placeholder="Weekly/Periodic Maintenance Days" min="0">
        </mat-form-field>
      </span>

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="routineMaintenance" id="routineMaintenance"              
              (ngModelChange)="routineMaintenanceChanging($event)" [(ngModel)]="item.routineMaintenance"              
              (ngModelChange)="routineMaintenanceChanged($event)" #routineMaintenance i18n="@@type.AssetType.routineMaintenance">
Routine Maintenance          </mat-slide-toggle>        
        </span>
      </span>

      <span>
        <mat-form-field matTooltip="Routine Maintenance Days" [matTooltipDisabled]="disabledTooltip(this.routineMaintenanceDays)">
          <mat-label i18n="@@type.AssetType.routineMaintenanceDays">Routine Maintenance Days</mat-label>
          <input matInput formControlName="routineMaintenanceDays" id="routineMaintenanceDays"              
              (ngModelChange)="routineMaintenanceDaysChanging($event)" [(ngModel)]="item.routineMaintenanceDays"              
              (ngModelChange)="routineMaintenanceDaysChanged($event)" #routineMaintenanceDays              
              type="number" placeholder="Routine Maintenance Days"  min="0">
        </mat-form-field>
      </span>

    </div>

    <mat-divider></mat-divider>

    <div class="crud-item-section">
      <h2>Mechanical</h2>

    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Mechanical Aspect Requirement from the list" [matTooltipDisabled]="disabledTooltip(this.mechanicalAspectRequirement)">
          <mat-label i18n="@@type.AssetType.mechanicalAspectRequirement">Mechanical Aspect</mat-label>
          <mat-select formControlName="mechanicalAspectRequirement" id="mechanicalAspectRequirement"              
              (ngModelChange)="mechanicalAspectRequirementChanging($event)" [(ngModel)]="item.mechanicalAspectRequirement"              
              (ngModelChange)="mechanicalAspectRequirementChanged($event)" #mechanicalAspectRequirement              
              placeholder="Mechanical Aspect Requirement">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let mechanicalAspectRequirement of mechanicalAspectRequirementSelectionList" [value]="mechanicalAspectRequirement.code">
              {{mechanicalAspectRequirement.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>
  
    <div class="crud-item-section">
      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="wbv" id="wbv"              
              (ngModelChange)="wbvChanging($event)" [(ngModel)]="item.wbv"              
              (ngModelChange)="wbvChanged($event)" #wbv i18n="@@type.AssetType.wbv">
Wbv          </mat-slide-toggle>        
        </span>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Wbv Rag Status from the list" [matTooltipDisabled]="disabledTooltip(this.wbvRagStatus)">
          <mat-label i18n="@@type.AssetType.wbvRagStatus">Wbv Rag Status</mat-label>
          <mat-select formControlName="wbvRagStatus" id="wbvRagStatus"              
              (ngModelChange)="wbvRagStatusChanging($event)" [(ngModel)]="item.wbvRagStatus"              
              (ngModelChange)="wbvRagStatusChanged($event)" #wbvRagStatus              
              placeholder="Wbv Rag Status">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let wbvRagStatus of ragStatusSelectionList" [value]="wbvRagStatus.code">
              {{wbvRagStatus.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>

      <span>
        <span>
          <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
              formControlName="havs" id="havs"              
              (ngModelChange)="havsChanging($event)" [(ngModel)]="item.havs"              
              (ngModelChange)="havsChanged($event)" #havs i18n="@@type.AssetType.havs">
Havs          </mat-slide-toggle>        
        </span>
      </span>

      <span>
        <mat-form-field matTooltip="Select a Havs Rag Status from the list" [matTooltipDisabled]="disabledTooltip(this.havsRagStatus)">
          <mat-label i18n="@@type.AssetType.havsRagStatus">Havs Rag Status</mat-label>
          <mat-select formControlName="havsRagStatus" id="havsRagStatus"              
              (ngModelChange)="havsRagStatusChanging($event)" [(ngModel)]="item.havsRagStatus"              
              (ngModelChange)="havsRagStatusChanged($event)" #havsRagStatus              
              placeholder="Havs Rag Status">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let havsRagStatus of ragStatusSelectionList" [value]="havsRagStatus.code">
              {{havsRagStatus.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>

    <mat-divider></mat-divider>
  
    <div class="crud-item-section">
      <h2>Electrical</h2>
    </div>

    <div class="crud-item-section">
      <span>
        <mat-form-field matTooltip="Select a Electrical Aspect Requirement from the list" [matTooltipDisabled]="disabledTooltip(this.electricalAspectRequirement)">
          <mat-label i18n="@@type.AssetType.electricalAspectRequirement">Electrical Aspect</mat-label>
          <mat-select formControlName="electricalAspectRequirement" id="electricalAspectRequirement"              
              (ngModelChange)="electricalAspectRequirementChanging($event)" [(ngModel)]="item.electricalAspectRequirement"              
              (ngModelChange)="electricalAspectRequirementChanged($event)" #electricalAspectRequirement              
              placeholder="Electrical Aspect Requirement">
            <mat-option>Any</mat-option>
            <mat-option *ngFor="let electricalAspectRequirement of electricalAspectRequirementSelectionList" [value]="electricalAspectRequirement.code">
              {{electricalAspectRequirement.meaning}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </span>
    </div>
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Portable Appliance Testing Days" [matTooltipDisabled]="disabledTooltip(this.portableApplianceTestingDays)">
          <mat-label i18n="@@type.AssetType.portableApplianceTestingDays">Portable Appliance Testing Days</mat-label>
          <input matInput formControlName="portableApplianceTestingDays" id="portableApplianceTestingDays"              
              (ngModelChange)="portableApplianceTestingDaysChanging($event)" [(ngModel)]="item.portableApplianceTestingDays"              
              (ngModelChange)="portableApplianceTestingDaysChanged($event)" #portableApplianceTestingDays              
              type="number" placeholder="Portable Appliance Testing Days"  min="0">
        </mat-form-field>
      </span>

    </div>
    <mat-divider></mat-divider>
  
    <div class="crud-item-section">

      <span>
        <mat-form-field matTooltip="Comments" [matTooltipDisabled]="disabledTooltip(this.comments)" class="crud-item-input-verywide">
          <mat-label i18n="@@type.AssetType.comments">Comments</mat-label>
          <textarea matInput formControlName="comments" id="comments"              
              (ngModelChange)="commentsChanging($event)" [(ngModel)]="item.comments"              
              (ngModelChange)="commentsChanged($event)" #comments              
              maxlength="2000" placeholder="Comments"></textarea>
        </mat-form-field>
      </span>


    </div>
    <mat-divider></mat-divider>
  
    <div class="crud-item-section">
      <h2>Guidance Text</h2>
    </div>
  
    <div class="crud-item-section">
      <span class="guidance-text-span">
        <!-- <mat-form-field matTooltip="Guidance Text" [matTooltipDisabled]="disabledTooltip(this.guidanceText)" class="crud-item-input-verywide">
          <mat-label i18n="@@type.AssetType.guidanceText">Guidance Text</mat-label>
          <textarea matInput formControlName="guidanceText" id="guidanceText" class="textarea-full-wide"        
              (ngModelChange)="guidanceTextChanging($event)" [(ngModel)]="item.guidanceText"              
              (ngModelChange)="guidanceTextChanged($event)" #guidanceText              
              maxlength="255" placeholder="Guidance Text"></textarea>
        </mat-form-field> -->
        <app-rich-text-section #guidanceTextEditor [(text)]="item.guidanceText" [readOnly]="readOnly" [editAvailable]="!readOnly" [editToggleAvailable]="!readOnly">
        </app-rich-text-section>
      </span>

    </div>
    <mat-divider></mat-divider>
  

  
    <div class="crud-item-section" *ngIf="!createMode">

      
      <span>
        <mat-form-field matTooltip="Created By" [matTooltipDisabled]="disabledTooltip(this.createdBy)">
          <mat-label i18n="@@type.AssetType.createdBy">Created By</mat-label>
          <input matInput formControlName="createdBy" id="createdBy"              
              (ngModelChange)="createdByChanging($event)" [ngModel]="item.createdBy"              
              (ngModelChange)="createdByChanged($event)" #createdBy disabled           
              maxlength="255" placeholder="Created By">
        </mat-form-field>
      </span>

      <span>
        <mat-form-field matTooltip="Created Date" [matTooltipDisabled]="disabledTooltip(this.createdDate)">
          <mat-label i18n="@@type.AssetType.createdDate">Created Date</mat-label>
          <input matInput formControlName="createdDate" id="createdDate"              
              (ngModelChange)="createdDateChanging($event)" [ngModel]="item.createdDate"              
              (ngModelChange)="createdDateChanged($event)" #createdDate disabled             
              [matDatepicker]="createdDateDatePicker" placeholder="Created Date">
          <mat-datepicker-toggle matSuffix [for]="createdDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #createdDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>
    
      <span>
        <mat-form-field matTooltip="Updated By" [matTooltipDisabled]="disabledTooltip(this.updatedBy)">
          <mat-label i18n="@@type.AssetType.updatedBy">Updated By</mat-label>
          <input matInput formControlName="updatedBy" id="updatedBy"              
              (ngModelChange)="updatedByChanging($event)" [ngModel]="item.updatedBy"              
              (ngModelChange)="updatedByChanged($event)" #updatedBy disabled             
              maxlength="255" placeholder="Updated By">
        </mat-form-field>
      </span>


      <span>
        <mat-form-field matTooltip="Updated Date" [matTooltipDisabled]="disabledTooltip(this.updatedDate)">
          <mat-label i18n="@@type.AssetType.updatedDate">Updated Date</mat-label>
          <input matInput formControlName="updatedDate" id="updatedDate"              
              (ngModelChange)="updatedDateChanging($event)" [ngModel]="item.updatedDate"              
              (ngModelChange)="updatedDateChanged($event)" #updatedDate disabled              
              [matDatepicker]="updatedDateDatePicker" placeholder="Updated Date">
          <mat-datepicker-toggle matSuffix [for]="updatedDateDatePicker"></mat-datepicker-toggle>
          <mat-datepicker #updatedDateDatePicker color="primary"></mat-datepicker>
        </mat-form-field>
      </span>



    </div>
    <mat-divider></mat-divider>
  
  </form>
</div>